// extracted by mini-css-extract-plugin
export default {"activeTopDetailsContainer":"SupbscriptionPlan_activeTopDetailsContainer__x6tTV","detailItem":"SupbscriptionPlan_detailItem__njKTV"};